import { useState } from 'react';
import { ChevronLeft, ChevronRight, Play } from 'lucide-react';

export default function VideoCarousel({ videos, posterImage, title }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const currentVideo = videos[currentIndex];
  const currentThumbnail = currentVideo.thumbnail || posterImage;

  const goToPrevious = () => {
    setIsPlaying(false);
    setCurrentIndex((prev) => (prev === 0 ? videos.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setIsPlaying(false);
    setCurrentIndex((prev) => (prev === videos.length - 1 ? 0 : prev + 1));
  };

  const handlePlay = () => {
    setIsPlaying(true);
  };

  return (
    <div className="space-y-4">
      {/* Video Player */}
      <div className="relative aspect-video bg-[#121212] overflow-hidden rounded-sm">
        {!isPlaying ? (
          <>
            <img
              src={currentThumbnail}
              alt={title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/40" />
            <button
              onClick={handlePlay}
              className="absolute inset-0 flex items-center justify-center group"
              aria-label={`Play ${currentVideo.title}`}
            >
              <div className="w-20 h-20 rounded-full bg-[#007AFF] flex items-center justify-center transition-transform group-hover:scale-110">
                <Play size={32} className="text-white ml-1" />
              </div>
            </button>
          </>
        ) : (
          <iframe
            src={`https://player.vimeo.com/video/${currentVideo.id}?autoplay=1&title=0&byline=0&portrait=0`}
            className="absolute inset-0 w-full h-full"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title={currentVideo.title}
          />
        )}
      </div>

      {/* Navigation Controls */}
      <div className="flex items-center justify-between">
        <button
          onClick={goToPrevious}
          className="flex items-center gap-2 px-4 py-2 border border-[#27272A] text-[#A1A1AA] hover:border-[#007AFF] hover:text-[#007AFF] transition-colors"
          data-testid="video-prev"
        >
          <ChevronLeft size={18} />
          Previous
        </button>

        {/* Dots indicator */}
        <div className="flex items-center gap-2">
          {videos.map((video, index) => (
            <button
              key={`dot-${video.id || video.vimeoId || index}`}
              onClick={() => {
                setIsPlaying(false);
                setCurrentIndex(index);
              }}
              className={`w-2 h-2 rounded-full transition-colors ${
                index === currentIndex ? 'bg-[#007AFF]' : 'bg-[#27272A] hover:bg-[#52525B]'
              }`}
              aria-label={`Go to ${video.title}`}
            />
          ))}
        </div>

        <button
          onClick={goToNext}
          className="flex items-center gap-2 px-4 py-2 border border-[#27272A] text-[#A1A1AA] hover:border-[#007AFF] hover:text-[#007AFF] transition-colors"
          data-testid="video-next"
        >
          Next
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
}
